export default {
    newDesign: true,
    title: "3 soruyu yanıtlayın ve ÜCRETSİZ eğlenceli bir matematik dersi alın | Kodland",
    downtimeUrl: "https://www.kodland.org/tr",
    parameters: {
        landing_id: "TrSpGtsAtest2",
        segment: 52,
    },
    startPage: {
        title:
            "3 kısa soruya yanıt verin ve ÜCRETSİZ matematik dersinizi alın!",
        subtitle:
            "Çocuğunuzun hangi seviyede olduğunu görün, zayıf yönlerini nasıl güçlendirebileceğinizi öğrenin ve ona matematiği sevmesi için güven ve motivasyon kazandırın — okul ve LGS sınavlarına mükemmel hazırlık.",
        image: {
            url: "/welcome/tr_sp_math_grades_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/tr_sp_math_grades_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Ücretsiz almak için tıklayın",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
    },
    quizRotateBySteps: {
        1: {
            question: "Çocuğunuz şu anda matematik hakkında nasıl hissediyor?",
            answers: [
                "😟 Çocuğum matematikte zorlanıyor ve bu konuda genelde endişe duyuyor",
                "😐 Çocuğum matematiği sevmiyor ve çalışmak için motivasyonu düşük",
                "🙂 Çocuğum fena değil ama bazı konularda eksikleri var",
                "🤓 Çocuğum matematiği seviyor ve yeni zorluklar arıyor"
            ]
        },
        2: {
            question: "Çocuğunuz LGS’ye ne zaman girecek?",
            answers: [
                "🚨 2026’da",
                "⚠️ 2027’de",
                "⏳ 2028’de",
                "📅 2029’da",
                "🤔 Henüz emin değilim"
            ],
        },
        3: {
            question: "Ücretsiz matematik dersinde ulaşmak istediğiniz en önemli hedef nedir?",
            answers: [
                "🚀 Çocuğumun matematiğe karşı ilgisini ve motivasyonunu artırmak",
                "💖 Çocuğumun stresini azaltıp özgüvenini güçlendirmek",
                "🔍 Çocuğumun mevcut matematik seviyesini ve geliştirilmesi gereken alanları öğrenmek",
                "🥇 LGS matematik hazırlığı için en iyi stratejiyi öğrenmek"
            ],
        },
        4: {
            title: "Çocuğunuzun Yaşını Seçin",
            subtitle: "Uzman öğretmenlerimiz, çocuğunuzun matematik özgüveni kazanmasını ve okul performansını artırmasını sağlar.",
            type: "age",
            button: "",
        },
        5: {
            question:
                "Çocuğunuzun çevrim içi dersler için bir bilgisayara (masaüstü veya dizüstü) erişimi var mı?",
            answers: [
                "👍 Evet",
                {
                    answer: "👎 Hayır",
                    stopAnswer: true,
                },
            ],
        },
        6: {
            title: "ÜCRETSİZ matematik deneme dersi için bir tarih seçin!",
            typeInfo: "congrats",
            subtitle:
                "Çocuğunuzun matematik becerilerini geliştirecek stresiz bir deneyim için yerinizi ayırtın.",
            button: "📅 Ücretsiz Dersimi Planla",
        },
        7: {
            title: "Ücretsiz ders rezervasyonu yapın",
            type: "one-page-contacts",
            subtitle: "",
            button: "Neredeyse bitti 🔥",
        },
        8: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        9: {
            title:
                "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Lütfen not edin:<br>• Çalışan bir bilgisayar veya dizüstü gerekli.<br>• Ders sırasında ebeveyn bulunmalı.<br>• Dersler, özgüveni ve matematik başarısını artırmak için kişiselleştirilmiştir.Adım adım matematik zorluklarını aşalım!",
            button: "Sırada ne var?",
        },
        10: {
            title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
            button: "Başka neler var?",
        },
        11: {
            title: "Ders platformumuzda gerçekleşecek 💻",
            typeInfo: "classroom",
            subtitle:
              "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
            button: "Anladım ✅",
        }
    },
};